export default "__VITE_ASSET__f8963e9b__"